import {
  RegistrationTokenType,
  SignInWithConnectBoardMutation,
} from "@/generated/graphql";
import { ErrorCode } from "@/libs/errors";
import { graphql, HttpResponse } from "msw";

// Mock Payloads
const successSignInPayload = {
  signInWithConnectBoard: {
    // token, registrationToken いずれかが返ってくる
    token: {
      access_token: "access_token", // サインインで取得したトークンを入れる
      id_token: "id_token",
      refresh_token: "refresh_token",
      token_type: "Bearer",
    },
  },
};

const successStartRegistrationCompanyPayload = {
  signInWithConnectBoard: {
    // token, registrationToken いずれかが返ってくる
    registrationToken: {
      type: RegistrationTokenType.Company,
      code: "xxxxxxxxxxxxx",
    },
  },
};

const successStartRegistrationUserPayload = {
  signInWithConnectBoard: {
    // token, registrationToken いずれかが返ってくる
    registrationToken: {
      type: RegistrationTokenType.User,
      code: "xxxxxxxxxxxxx",
    },
  },
};

const errorAlreadyConnectedPayload = {
  errors: [
    {
      extensions: {
        code: ErrorCode[ErrorCode.CONNBOARD_USER_IS_ALREADY_CONNECTED],
      },
    },
  ],
};

const errorRequestFailedPayload = {
  errors: [
    {
      extensions: {
        code:
          ErrorCode[ErrorCode.CONNBOARD_REQUEST_FAILED] +
          ": service time is over. [210]",
      },
    },
  ],
};

// Mock Cases
enum SignInWithConnectBoardMockCase {
  SuccessSignIn,
  SuccessStartRegistrationCompany,
  SuccessStartRegistrationUser,
  ErrorAlreadyConnected,
  ErrorRequestFailed,
}
const targetCase =
  SignInWithConnectBoardMockCase.SuccessStartRegistrationCompany; // ここでモックのケースを変更する

export const signInWithConnectBoardMutationHandler =
  graphql.mutation<SignInWithConnectBoardMutation>(
    "signInWithConnectBoard",
    ({ query, variables }) => {
      switch (Number(targetCase)) {
        case SignInWithConnectBoardMockCase.SuccessSignIn:
          return HttpResponse.json({ data: successSignInPayload });
        case SignInWithConnectBoardMockCase.SuccessStartRegistrationCompany:
          return HttpResponse.json({
            data: successStartRegistrationCompanyPayload,
          });
        case SignInWithConnectBoardMockCase.SuccessStartRegistrationUser:
          return HttpResponse.json({
            data: successStartRegistrationUserPayload,
          });
        case SignInWithConnectBoardMockCase.ErrorAlreadyConnected:
          return HttpResponse.json({
            data: {
              signInWithConnectBoard: {},
              ...errorAlreadyConnectedPayload,
            },
          });
        case SignInWithConnectBoardMockCase.ErrorRequestFailed:
          return HttpResponse.json({
            data: {
              signInWithConnectBoard: {},
              ...errorRequestFailedPayload,
            },
          });
      }
    }
  );
